const AlertStrings = {
  noInternetConnection: 'No internet connection available.',
};

export default AlertStrings;
